// extracted by mini-css-extract-plugin
export default {"wrap":"AnswerAttachments_wrap__glgDP","button":"AnswerAttachments_button__Giv9h"};